// extracted by mini-css-extract-plugin
module.exports = {"container":"email-item_container__3cnQ7","text":"email-item_text__11HlK","icon":"email-item_icon__n6JzS"};